import { ServerMarketplaceState } from '@yoop/server-model/marketplace';

/**
 * Predicate for cancelled marketplaces
 * @param marketplace
 */
export const cancelled = (marketplace: { state?: ServerMarketplaceState }): boolean =>
  marketplace && marketplace.state === ServerMarketplaceState.CANCELLED;
